import { supabase } from "@/lib/supabaseClient";

export interface LeadInput {
  kind: "contact" | "newsletter";
  email: string;
  name?: string;
  phone?: string;
  property_type?: string;
  size?: string;
  message?: string;
  lang?: "en" | "ar";
}

/**
 * Store a website lead (contact form / newsletter). The table is
 * insert-only for the anon key, so never chain .select() here — there
 * is no read policy and it would fail.
 */
export async function submitLead(input: LeadInput): Promise<void> {
  const clean = (v?: string) => (v && v.trim() ? v.trim() : null);
  const { error } = await supabase.from("marketing_leads").insert({
    kind: input.kind,
    email: input.email.trim(),
    name: clean(input.name),
    phone: clean(input.phone),
    property_type: clean(input.property_type),
    size: clean(input.size),
    message: clean(input.message),
    lang: input.lang ?? null,
  });
  if (error) throw new Error(error.message);
}
